import { TextField } from "./MyCustomFile"
export const MyFile = ({ label, setInputField, setBaseImage, file_name, setSelectedFile }) => {
    const uploadImage = async (e, field) => {
        const file = e.target.files[0];
        let maxSizeInBytes = 2 * 1024 * 1024; // 5MB in bytes
        if (file?.size > maxSizeInBytes) {
            alert('File size exceeds 2MB. Please upload a smaller file.');
            e.target.value = ''; // Clear the file input
            return;
        }
        setBaseImage((prevState) => ({ ...prevState, [field]: file ? URL.createObjectURL(file) : null }));
        setSelectedFile((prevState) => ({ ...prevState, [field]: file ? field === "file1" ? `gst_${file.name}` : `aadhar_${file.name}` : null }));
        const base64File = await convertBase64(file);
        setInputField((prevInputField) => ({ ...prevInputField, [field]: file ? { base64File, fileName: field === "file1" ? `gst_${file.name}` : `aadhar_${file.name}` } : null }));
    };
    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            if (file) {
                fileReader.readAsDataURL(file);
                fileReader.onload = () => resolve(fileReader.result);
                fileReader.onerror = (error) => reject(error);
            }
        });
    };
    return (<>
        <TextField
            fullWidth
            type="file"
            variant="outlined"
            margin="dense"
            size="small"
            label={label}
            onChange={(e) => uploadImage(e, file_name)}
            InputLabelProps={{ shrink: true }}
            inputProps={{
                accept: ".png,.jpg,.jpeg,.pdf,.docs,.docx,.csv",
                onChange: (e) => uploadImage(e, file_name)
            }}
        />
    </>);
}